<template>
  <div class="attachments-view">
    <div class="card border-0">
      <div class="card-body pt-0 pl-0 pr-0" style="background-color: #E3E8EE">
        <div class="row">
          <div class="col-xl-8 col-lg-12">
            <attachment-list :delete-permission="'delete_customer'" :change-permission="'change_customer'"
                             :object-uuid="customer.uuid" plural-object-name="customers" object-name="customer"/>
          </div>
          <div class="col-xl-4 col-lg-12 mt-sm-3 mt-xl-0">
            <customer-logo-uploader></customer-logo-uploader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import AttachmentList from "@/modules/attachments/AttachmentList";
  import CustomerLogoUploader from "@/modules/customer/view/attachments/CustomerLogoUploader";

  const {mapState} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "Attachments",
    components: {CustomerLogoUploader, AttachmentList},
    computed: {
      ...mapState({
        customer: state => state.customer,
      })
    }
  }
</script>

<style scoped>
</style>
